import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
  withCredentials: true,
});

export const geocode = async (query) => {
  const { data } = await api.get(`/geocode`, { params: { q: query, limit: 6 } });
  return data;
};

export const reverseGeocode = async (lat, lon) => {
  const { data } = await api.get(`/reverse-geocode`, { params: { lat, lon } });
  return data;
};

export const compareFares = async (pickup, drop) => {
  const { data } = await api.post(`/compare`, { pickup, drop });
  return data;
};

export const getComparison = async (id) => {
  const { data } = await api.get(`/comparison/${id}`);
  return data;
};
